import HTML5Audio from './html5_audio'
export default HTML5Audio



// WEBPACK FOOTER //
// ./src/playbacks/html5_audio/index.js